import { DeleteOutlined } from '@ant-design/icons';
import { GenericModelSchemaType } from '@smx-ui-model/types';
import { Button, Popconfirm } from 'antd';
import * as React from 'react';
import { memo, useContext, useEffect } from 'react';
import { useMutation } from 'react-relay';
import { MutationParameters, PayloadError } from 'relay-runtime';

import { SmxInspectorContext } from './inspector-provider';

interface FormButtonCreateProps {
    model: GenericModelSchemaType;
    connectionId: string;
}

const FormButtonDelete: React.FC<FormButtonCreateProps> = ({ model, connectionId }) => {
    const { currentId } = useContext(SmxInspectorContext);
    const [commitDelete, isInFlightDelete] = useMutation(model.mutation!.delete!);
    const { setIsOpen, setIsLoading } = useContext(SmxInspectorContext);

    useEffect(() => {
        setIsLoading?.(isInFlightDelete);
    }, [isInFlightDelete]);

    const commitModel = (): MutationParameters => {
        return {
            variables: {
                id: currentId,
                connections: [connectionId],
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                } else {
                    setIsOpen?.(false);
                    console.log('Item delete successful', response);
                }
            },
            onError: (error: any) => {
                console.error('Mutation error:', error);
            },
        } as unknown as MutationParameters;
    };

    const handleClick = async () => {
        if (currentId) {
            commitDelete(commitModel());
        }
    };

    return (
        <>
            {currentId && (
                <Popconfirm
                    title="Delete the unit"
                    description="Are you sure to delete this unit?"
                    onConfirm={handleClick}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button icon={<DeleteOutlined />} danger loading={isInFlightDelete}>
                        Delete
                    </Button>
                </Popconfirm>
            )}
        </>
    );
};

export default memo(FormButtonDelete);
